import { useEffect, useState } from 'react';
import { Card, Grid, IconButton, Typography } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import axios from "axios"

const DashboardComponent = () => {
    const [dashboards, setDashboards] = useState([]);

    const fetchDashboards = async () => {
        try {
            let images = [];

            const response = await axios.get(process.env.REACT_APP_OBSERVABILITY_DASHBOARD_BASE_URL +'/getDashboards');
            const data = response.data.dashboards;

            data.map((dashboard) => {
                const widgetTest = dashboard.widget;
                const widgetValues = Object.values(widgetTest);

                const base64String = btoa(String.fromCharCode(...new Uint8Array(widgetValues)));

                // Set the Base64 string as the image source
                images.push(`data:image/png;base64,${base64String}`);
            });

            setDashboards(images);

        } catch (error) {
            console.error('Error fetching dashboards:', error);
        }
    };

    useEffect(() => {
        fetchDashboards();
    }, []);

    return (
        <>
            <Typography gutterBottom variant="h1" component="h1">
                <span className='cardcontain'>EDI Observability Dashboard</span>
            </Typography>
            <Card className="p-4">
                <Grid container justifyContent="flex-end" padding={2}>
                    <Grid item>
                        <IconButton onClick={fetchDashboards} style={{ border: '1px solid black' }}>
                            <ReplayIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid padding={1} container alignItems="center" spacing={20}>
                    { dashboards.map((imageSrc) =>
                        <Grid item xs={2} sm={6}>
                            <img src={imageSrc} alt="widget" />
                        </Grid>
                        )
                    }
                </Grid>
            </Card>
        </>
    )
}

export default DashboardComponent;
